import { render, staticRenderFns } from "./Nagoya.vue?vue&type=template&id=2f41bc91&scoped=true&"
import script from "./Nagoya.vue?vue&type=script&lang=js&"
export * from "./Nagoya.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f41bc91",
  null
  
)

export default component.exports